// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__2QNGe","text":"styles_text__iG5TB","chevron":"styles_chevron__7wImN","skeleton-animation":"styles_skeleton-animation__woZmz"};